import { Navigate } from 'react-router-dom';
import { useVisibleSections } from '@/hooks/useVisibleSections';
import { WinclapLoader } from '@/components/ui/winclap-loader';

/**
 * /admin/users — redirección al primer subpanel que el usuario pueda abrir.
 *
 * Antes acá vivía una MAQUETA que se deployó por error: un botón "Nueva
 * Solicitud" sin onClick, una tarjeta con el texto fijo "No hay solicitudes
 * pendientes" (no era una query, era un string) y otra clavada para siempre en
 * "Cargando datos de Google Workspace…". Nada estaba conectado a nada, así que
 * cualquiera que llegara con un bookmark viejo concluía que el sistema estaba
 * roto o vacío. Los paneles de verdad son los hijos de esta ruta (Clappi,
 * Oficinas, Pedidos, In/out…).
 *
 * Se redirige al PRIMER item visible del grupo, no a uno fijo, porque la
 * audiencia cambia por rol y subtab denegado — mismo criterio que usa la card
 * "Experience" (ex "Existencial", Sol 18/09) del Home (DashboardPage).
 */
export function UserManagementPage() {
  const { peopleGroups, isAccessLoading } = useVisibleSections();

  if (isAccessLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <WinclapLoader size={48} className="text-foreground/25" />
      </div>
    );
  }

  const usersGroup = peopleGroups.find((g) => g.key === 'PeopleHub:users');
  const target = usersGroup?.items[0]?.href ?? '/dashboard';

  return <Navigate to={target} replace />;
}
